module.exports = __webpack_public_path__ + "img/ico_news_board.76253f06.svg";